import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { TaskPane } from './components/TaskPane';

// Office.onReady gates the app until the Office.js runtime is loaded.
// In the browser (for dev/testing outside Outlook), it resolves immediately with host = null.
Office.onReady(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <TaskPane />
    </StrictMode>,
  );
});
